import * as Sentry from '@sentry/react'

export const sentryInit = () => {
  Sentry.init({
    dsn: window.marketplace.state.app.sentry && window.marketplace.state.app.sentry.dsn,
    normalizeDepth: 10,
    beforeSend (event) {
      let excludedErrors = [
        't[n].getSlotId is not a function',
        'Unable to get property \'contains\' of undefined or null reference',
        'Undefined property: stdclass:$sessionInfo'
      ]

      if (event.exception.values) {
        // Iterate through events, remove those on the exclude list
        event.exception.values.forEach(function (exception, index, object) {
          if (excludedErrors.includes(exception.value)) {
            object.splice(index, 1)
          }
        })

        if (event.exception.values.length <= 0) {
          return false
        }
      } else if (event.exception.value && excludedErrors.includes(event.exception.value)) {
        return false
      }

      return event
    }
  })
}

export const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  configureScopeWithState: (scope, state) => {
    if (state.app.user) {
      scope.setUser({
        id: state.app.user.id,
        email: state.app.user.email
      })
    }
  }
})
